import React from 'react';
import { useSelector } from 'react-redux';
import { ActionButton, Button, ButtonGroup, Content, Dialog, DialogTrigger, Divider, Heading, useDialogContainer, } from '@adobe/react-spectrum';
import { deletePage } from 'app/stores/project/actions/selectPage';
import { getPagesCount } from 'app/stores/selectors';
import { useAppDispatch } from 'app/stores/store';
const ConfigDialog = () => {
    const dialog = useDialogContainer();
    const dispatch = useAppDispatch();
    const onConfim = React.useCallback(() => {
        dispatch(deletePage({}));
        dialog.dismiss();
    }, [dialog, dispatch]);
    return (React.createElement(Dialog, null,
        React.createElement(Heading, null, "Delete slide"),
        React.createElement(Divider, null),
        React.createElement(Content, null, "Confirm slide deletion?"),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { variant: "secondary", onPress: dialog.dismiss }, "Cancel"),
            React.createElement(Button, { variant: "cta", onPress: onConfim, autoFocus: true }, "Confirm"))));
};
export const DeletePageButton = () => {
    const canDeletePage = useSelector((state) => getPagesCount(state) > 1);
    if (!canDeletePage) {
        return null;
    }
    return (React.createElement(DialogTrigger, null,
        React.createElement(ActionButton, { "data-test-id": "header-delete-slide", isQuiet: true }, "Delete Slide"),
        React.createElement(ConfigDialog, null)));
};
